"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_TO_CHANNEL = void 0;
const intl_menu_1 = require("@rbilabs/intl-menu");
const types_1 = require("../types");
/**
 * Maps the Cart Platform into Menu Service Channel
 */
exports.PLATFORM_TO_CHANNEL = {
    [types_1.Platform.app]: intl_menu_1.Channel.whitelabel,
    [types_1.Platform.web]: intl_menu_1.Channel.whitelabel,
    [types_1.Platform.biteninja]: intl_menu_1.Channel.biteninja,
    [types_1.Platform.googleFoodOrdering]: intl_menu_1.Channel.gfo,
    [types_1.Platform.waitr]: intl_menu_1.Channel.waitr,
    [types_1.Platform.skip]: intl_menu_1.Channel.skip,
    [types_1.Platform.uber]: intl_menu_1.Channel.uber,
    [types_1.Platform.doordash]: intl_menu_1.Channel.doordash,
    [types_1.Platform.grubhub]: intl_menu_1.Channel.grubhub,
    [types_1.Platform.bookingall]: '',
    [types_1.Platform.internal]: '',
    [types_1.Platform.kiosk]: '',
};
//# sourceMappingURL=cart-platform-mapping.js.map